module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"dataType":"Veri Tipi","emissionType":"Emisyon Tipi","date":"Son değişme tarihi","dataTypeHasEmission":"Emisyon Faktörü Olan Veri Tipleri"},"en":{"dataType":"Data Type","emissionType":"Emission Type","date":"Last Updated Date","dataTypeHasEmission":"Data Types Have an Emission Factor"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Setting/EmissionTable.vue
// module id = VZFw
// module chunks = 1